import React, { createContext, useEffect, useState } from "react";
import { SidebarSection } from "./quote/sidebar";
import { MainSection } from "./quote/mainSection";
import { AmountSection } from "./quote/amountSection";

let sidebarData = [
  {
    id: 1,
    heading: "Printed Book Distribution",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 2,
    heading: "Text Formatting",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 3,
    heading: "Cover Design",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 4,
    heading: "ISBN – Printed Books",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 5,
    heading: "Recommended For You",
    subHeading: "Selection(s) optional",
    projectType: "PrintedBooks",
  },
  {
    id: 6,
    heading: "Save Project",
    subHeading: "Enter a quote name",
    projectType: "PrintedBooks",
  },
];

let ebookDistribution = [
  {
    id: 1,
    heading: "eBook Distribution",
    subHeaidng: "eBook Conversion (w/ Distribution)",
  },
  {
    id: 2,
    heading: "eBook Formatting",
    subHeaidng: "Selection required",
  },
  {
    id: 3,
    heading: "ebook Cover Design",
    subHeaidng: "I am supplying my eBook cover",
  },
  {
    id: 4,
    heading: "ISBN – eBooks",
    subHeaidng: "I already have an ISBN for my eBook",
  },
  {
    id: 5,
    heading: "eBook File Conversion",
    subHeaidng: "Selection required",
  },
  {
    id: 6,
    heading: "Images – eBooks",
    subHeaidng: "Selection required",
  },
  {
    id: 7,
    heading: "Recommended For You",
    subHeaidng: "Selection(s) optional",
  },
  {
    id: 8,
    heading: "Save Project",
    subHeaidng: "Enter a quote name",
  },
];
let eBookAndPrinted = [
  {
    id: 1,
    heading: "Printed Book Distribution",
    subHeading: "Selection required",
  },
  {
    id: 2,
    heading: "Text Formatting",
    subHeading: "Selection required",
  },
  {
    id: 3,
    heading: "Cover Design",
    subHeading: "Selection required",
  },
  {
    id: 4,
    heading: "ISBN – Printed Books",
    subHeading: "Selection required",
  },
  {
    id: 5,
    heading: "ISBN – eBooks",
    subHeading: "Selection required",
  },
  {
    id: 6,
    heading: "eBook File Conversion",
    subHeading: "Selection required",
  },
  {
    id: 7,
    heading: "Images – eBooks",
    subHeading: "Selection required",
  },
  {
    id: 8,
    heading: "Recommended For You",
    subHeading: "Selection(s) optional",
  },
  {
    id: 9,
    heading: "Save Project",
    subHeading: "Enter a quote name",
    projectType: "PrintedBooks",
  },
];

export const DataContext = createContext(null);
export const MainPage = () => {
  const [displayedSidebar, setDisplaySidebar] = useState(sidebarData); // Initially, show the first 6 images
  let [amountValue, setAmountValue]=useState(99)

  const [count, setCount] = useState(0);
  let [selectValue, setSelectValue] = useState({
    section1: null,
    section2: null,
    section3: null,
    section4: null,
    section5: null,
  });
  let [liData, setLiData] = useState(1);
  const getLiData = (id) => {
    let filterData = sidebarData.filter((value) => value.id == id);
    console.log("filterData", filterData);
    setLiData(filterData[0].id);
  };
  console.log("selectValueselectValue", selectValue);
  const onChangeAllValue = (e) => {
    setSelectValue({ ...selectValue, section1: e.currentTarget.value });
  };
  const onSectionTwo = (e) => {
    setSelectValue({ ...selectValue, section2: e.currentTarget.value });
  };
  const onSectionThree = (e) => {
    setSelectValue({ ...selectValue, section3: e.currentTarget.value });
  };

  const onSectionFour = (e) => {
    setSelectValue({ ...selectValue, section4: e.currentTarget.value });
  };

  const onSectionFive = (e) => {
    setSelectValue({ ...selectValue, section5: e.currentTarget.value });
  };

  const onSectionSix = (e) => {
    setSelectValue({ ...selectValue, section6: e.currentTarget.value });
  };

  const handleFilterKeyChange = (filter) => {
    // Depending on the active button, set the appropriate data array.
    switch (filter) {
      case "printedbooks":
        setDisplaySidebar(sidebarData);
        break;
      case "ebook":
        setDisplaySidebar(ebookDistribution);
        break;
      case "ebook&printed":
        setDisplaySidebar(eBookAndPrinted);
        break;
      default:
        // Default to 'logo'
        setDisplaySidebar(sidebarData);
    }
  };

  let clickData=() =>{
    handleFilterKeyChange("ebook&printed");
  }
  useEffect(() =>{
    // if ()
    let printedbooks= 99;
    if(selectValue.section1 != null){
      setAmountValue(Number(selectValue.section1) + printedbooks);
    }
  },[selectValue])
// handleFilterKeyChange("ebook");
  return (
    <DataContext.Provider
      value={{
        count,
        setCount,
        sidebarData,
        getLiData,
        liData,
        setSelectValue,
        selectValue,
        onChangeAllValue,
        onSectionTwo,
        onSectionThree,
        onSectionFour,
        onSectionFive,
        onSectionSix,
        displayedSidebar,
        clickData,
        amountValue
      }}
    >
      <div className="w-full flex justify-between">
        <SidebarSection />
        <MainSection />
        <AmountSection />
      </div>
    </DataContext.Provider>
  );
};
